// tslint:disable
/**
 * Robotic Platform Pattern Generation API
 * WebSocket API contract for generating palletization strategy templates and layer layouts.  This module is exposed through the Robotic Platform WebSocket dispatcher (not a standalone REST API). The OpenAPI path below documents the JSON request/response message payload for the `generatePatternPlan` handler.  Transport notes: - Connect to the WebSocket server and send a JSON object with top-level `type: generatePatternPlan` - Receive one JSON response frame for the request (success or handler-level error) - Validation and internal handler errors are encoded in the JSON response body with `status: error` - No module-level authentication or rate limiting is implemented in this repository 
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Pallet subsection used to constrain placements. Unknown fields are ignored by the backend.  If any ratio field is provided, backend treats the section as `custom`. 
 * @export
 * @interface PalletSection
 */
export interface PalletSection {
    [key: string]: object | any;

    /**
     * Section preset (parsed case-insensitively by backend).
     * @type {string}
     * @memberof PalletSection
     */
    preset?: PalletSectionPresetEnum;
    /**
     * Must be strictly lower than `max_x_ratio` when provided.
     * @type {number}
     * @memberof PalletSection
     */
    min_x_ratio?: number;
    /**
     * 
     * @type {number}
     * @memberof PalletSection
     */
    max_x_ratio?: number;
    /**
     * Must be strictly lower than `max_y_ratio` when provided.
     * @type {number}
     * @memberof PalletSection
     */
    min_y_ratio?: number;
    /**
     * 
     * @type {number}
     * @memberof PalletSection
     */
    max_y_ratio?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum PalletSectionPresetEnum {
    FULL = 'full',
    HALF_LEFT = 'half_left',
    HALF_RIGHT = 'half_right',
    HALF_TOP = 'half_top',
    HALF_BOTTOM = 'half_bottom',
    QUARTER_TOP_LEFT = 'quarter_top_left',
    QUARTER_TOP_RIGHT = 'quarter_top_right',
    QUARTER_BOTTOM_LEFT = 'quarter_bottom_left',
    QUARTER_BOTTOM_RIGHT = 'quarter_bottom_right',
    CUSTOM = 'custom'
}



